var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.grid},_vm._l((_vm.systemUuids),function(systemUuid){return _c('img',{key:systemUuid,attrs:{"src":("/stream/system/" + systemUuid + "/stream.jpg")},on:{"error":_vm.error}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }